export default {
      id: "icon-copy-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }